import React, { useState, useEffect } from "react";
import { Container, Row, Form, Card } from "react-bootstrap";
import default_car from "../../../../assets/default_car.svg";
import "./VehiclelistPage.css";
import pickup_location from "../../../../assets/pickup_location.svg";
import desti_location from "../../../../assets/desti_location.svg";
import pickup_time from "../../../../assets/pickup_time.svg";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import seats_icon from "../../../../assets/seats_icon.svg";
import bag_icon from "../../../../assets/bag_icon.svg";
import info_icon from "../../../../assets/cab_info_icon.svg";
import Modifypopup from "../../modifypopup/components/Modifypopup";
import { useTranslation } from "react-i18next";
import { maintainVehiclelist } from "../../../home/redux/actions";
import { maintainModify } from "../../../home/redux/actions";
import { postRequestcall } from "../../../comman/util/postRequest";
import { LIST_VEHICLE, SEARCH_NEW_DRIVER } from "../../../constants/apiurl";
import { getRequestcall } from "../../../comman/util/getRequest";
import PaginationPage from "../../../comman/components/PaginationPage";
import NodatafoundPage from "../../../nodatafound/components/NodatafoundPage";
import no_orders from "./../../../../assets/order_empty_icon.svg";
import { Day, LongMonth } from "../../../comman/components/Datetimeformat";
import { FormLabel } from "../../../comman/formgroup/FormgroupPage";
import SingleselectPage from "../../../comman/customselect/SingleselectPage";
import { fetchHeaderContent } from "../../../seoroute/redux/actions";
import { maintainCabbook } from "../../../home/redux/actions";
import moment from "moment";
import { ValidateTime } from "../../../comman/components/TimeSence";
import { SearchNewDriverPayload } from "../../../home/util/payloadData";

function VehiclelistPage(props) {

  const navigate = useNavigate();
  const [showinfo, setShowinfo] = useState();
  const [vehiclelist, setVehiclelist] = useState([]);
  const { t } = useTranslation();
  const [showtypes, setShowtypes] = useState(false);
  const [selectedtype, setSelectedtype] = useState({})

  // eslint-disable-next-line
  useEffect(() => {
    (async () => listVehiclerequest())();
    // eslint-disable-next-line
  }, [props?.language]);

  // eslint-disable-next-line
  useEffect(() => {
    props?.fetchHeaderContent(t("pages.meta.cab.title"), t("pages.meta.cab.description"), "");
    // eslint-disable-next-line
  }, [props?.language]);

  const listVehiclerequest = async () => {
    let getListvehicleResponse = await getRequestcall(
      LIST_VEHICLE,
      props?.access_token
    );
    if (getListvehicleResponse?.status === 200) {
      let getResponse = await getListvehicleResponse.json();
      if (getResponse?.data?.length !== 0) {
        let list = [];
        let vehicletype = {};
        getResponse.data.forEach((item) => {
          vehicletype = {
            value: item.id,
            label: item.vehicle_type,
            label_tr: item.vahicle_type_in_tr,
          };
          list.push(vehicletype);
        });
        let allObject = { value: "", label: "All", label_tr: "Tümü" }
        list.unshift(allObject);
        setVehiclelist(list);
        setSelectedtype(list[0])
        await callCablist("");
      }
    }
  };

  const vehicleListrender = (vehiclelist) => {
    let updatedlist = [];
    let updateObject = {};
    vehiclelist.forEach((item) => {
      updateObject = {
        value: item?.value,
        label: props.language === "Tr" ? item.label_tr : item.label,
        label_tr: item.label_tr,
      };
      updatedlist.push(updateObject);
    });
    return updatedlist;
  };

  const navigateTocabbook = (id) => {
    if (props.access_token) {
      navigate(`/cab-book/${id}`);
    } else {
      let cabBook = {
          flag:"cab_book",
          id:id
      }
      props?.maintainCabbook(cabBook);
      navigate("/login");
    }
  };

  const showFeature = (e, index) => {
    e.preventDefault();
    e.stopPropagation()
    if (showinfo === index) {
      setShowinfo();
    } else {
      setShowinfo(index);
    }
  };

  const selectVehicletype = async (e, selecttype, index) => {
    e.preventDefault();
    console.log("select type", selecttype)
    setSelectedtype(selecttype);
    await callCablist(selecttype?.value);
  };
  // Call driver list 
  const callCablist = async (vehicleType) => {
    const Payload = SearchNewDriverPayload(props, vehicleType, 1);
    let response = await postRequestcall(SEARCH_NEW_DRIVER,props.access_token,Payload);
    if (response?.status === 200) {
      let getList = await response.json();
      props.maintainVehiclelist(getList?.data);
    } else if (response.status === 400) {
      props.maintainVehiclelist([]);
    }
  }

  const handlePageChange = async (page) => {
    const payload = SearchNewDriverPayload(props, "", page)
    let response = await postRequestcall(SEARCH_NEW_DRIVER,props?.access_token,payload);
    if (response?.status === 200) {
      let getList = await response.json();
      props?.maintainVehiclelist(getList?.data);
    } else if (response.status === 400) {
      props.maintainVehiclelist([]);
    }
  }

  const renderSelectedtype = (getItem) => {
    let getValue = vehiclelist.filter((item) => item?.value === getItem?.value);
    if (getValue?.length > 0) {
      return props?.language === "Tr" ? getValue[0]?.label_tr : getValue[0]?.label;
    } else {
      return ""
    }
  }

  const seatsDetail = (type, item) => {
    return (
      type === "seats" ? (
        <div className="seats">
          <img src={seats_icon} alt="seats"></img>
          <h6 className="ms-2">
            {t("pages.vehicle_list.seats")}{" "}
            {item.number_of_seats}
          </h6>
        </div>
      ) : (
        <div className="seats mobile-view-bag">
          <img src={bag_icon} alt="bags"></img>
          <h6 className="ms-2">
            {t("pages.vehicle_list.bags")}{" "}
            {item?.vehicle_type_details?.num_of_bags_allowed}
          </h6>
        </div>
      )
    )
  }

  const moreInfo = (index) => {
    return (
      <div
        className="more-info"
        onClick={(e) => showFeature(e, index)}
      >
        <img src={info_icon} alt="info"></img>
        <label className="ms-2">
          {t("pages.vehicle_list.more_info")}
        </label>
      </div>
    )
  }

  return (
    <>

      <div className="vehicle-list">
        <Container>
          <div className="mobile-cab-info">
            <ul className="list-ic vertical">
              <li>
                <span></span>
                <div>
                  <label className="ms-2">
                    {t("pages.myrides.pickup_location")}
                  </label>
                  <h6 className="ms-2 location-address">
                    {props?.pickup?.from_place}
                  </h6>
                </div>
              </li>
              <li>
                <span className="dot-green"></span>
                <div>
                  <label className="ms-2">
                    {t("pages.myrides.destination_location")}
                  </label>
                  <h6 className="ms-2 location-address">
                    {props?.destination?.to_place}
                  </h6>
                </div>
              </li>
            </ul>
          </div>
          <div className="mobile-cab-time">
            <label>{t("pages.myrides.pickup_date")}</label>
            <h6><ValidateTime time={moment(props?.pickupdate_time).format('YYYY-MM-DD hh:mm A')}/></h6>
          </div>
          <div className="d-flex justify-content-end modify-background">
            <button
              type="submit"
              className="btn-submit mb-2 hover-btn modify"
              onClick={() => props?.maintainModify(true)}
            >
              {t("pages.vehicle_list.modify")}
            </button>
          </div>
          <div className="information mb-3">
            <Container>
              <Row>
                <div className="col-sm-12 col-md-12 col-lg-1 col-xl-1 ms-4 position-relative">
                  <div className="pick-date">
                    <h5><Day date={props?.pickupdate_time} /></h5>
                    <label className="date">
                      {t("pages.vehicle_list.pick_date")}
                    </label>
                    <label className="month">
                      {<LongMonth date={props?.pickupdate_time} />}
                    </label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 pickup">
                  <div className="location-info">
                    <img alt="pickup location" src={pickup_location}></img>
                    <div className="location-show">
                      <FormLabel require={false} label={t("pages.myrides.pickup_location")} />
                      <Form.Text>{props?.pickup?.from_place}</Form.Text>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3">
                  <div className="location-info">
                    <img alt="desti_location" src={desti_location}></img>
                    <div className="location-show">
                      <FormLabel require={false} label={t("pages.myrides.destination_location")} />
                      <Form.Text>{props?.destination?.to_place}</Form.Text>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                  <div className="location-info">
                    <img alt="pickup time" src={pickup_time}></img>
                    <div className="location-show">
                      <FormLabel require={false} label={t("pages.myrides.pickup_date")} />
                      <Form.Text><ValidateTime time={moment(props?.pickupdate_time).format('DD-MM-YYYY HH:mm A')}/></Form.Text>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2 ms-5 return-date">
                  <div className="location-info">
                    {props?.waytype?.id === 2 && (
                      <>
                        <img alt="pickup time" src={pickup_time}></img>
                        <div className="location-show">
                          <>
                            <FormLabel require={false} label={t("pages.myrides.return_date")} />
                            <Form.Text>
                              {typeof props?.returndate_time === "undefined" || props?.returndate_time === "" ? (
                                <></>
                              ) : (
                                <ValidateTime time={moment(props?.returndate_time).format('DD-MM-YYYY hh:mm A')}/>
                              )}
                            </Form.Text>
                          </>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Row>
            </Container>
          </div>
          <div className="list-info">
            <Row className="m-0">
              <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9 cab-detail-text">
                <h5 className="mt-2">{t("pages.vehicle_list.cabs_detail")}</h5>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 position-relative pe-0 ps-0">
                <SingleselectPage
                  groupItemClick={selectVehicletype}
                  value={renderSelectedtype(selectedtype)}
                  list={vehicleListrender(vehiclelist)}
                  setShowList={setShowtypes}
                  showList={showtypes}
                  placeholder={t("pages.vehicle_list.select_cab_type")}
                />
              </div>
            </Row>
            {/* Mobile cab list */}
            <section className="mobile-cab-list">
              {props?.vehiclelist?.data?.map((item, index) => (
                <Card onClick={() => navigateTocabbook(item.id)}>
                  <Card.Img src={
                    item?.vehicle_image === null
                      ? default_car
                      : item?.vehicle_image[0]
                  } />
                  <Card.Body >
                    <div className="cab-info d-flex flex-column">
                      <label>
                        {item?.vehicle_type_details?.car_model
                          .charAt(0)
                          .toUpperCase() +
                          item?.vehicle_type_details?.car_model.slice(1)}
                      </label>
                      <div className="d-flex flex-row align-items-baseline price-div">
                        {/* <h5>{(
                          props.destination.kilometer *
                          item?.vehicle_type_details?.kilometer_wise_price
                        ).toFixed(2)}{" "}{process.env.REACT_APP_CURRENCY_SYMBOL}</h5><span>{parseInt(props.destination.kilometer)} Kms</span> */}
                        <h5>{(item?.price_to_display) }{" "}{process.env.REACT_APP_CURRENCY_SYMBOL}</h5><span>{parseInt(props.destination.kilometer)} Kms
                        </span>
                      </div>
                    </div>
                    <div className="d-flex">
                      {seatsDetail("seats", item)}
                      {seatsDetail("bags", item)}
                    </div>
                    {moreInfo(index)}
                    {showinfo === index && (
                      <div className="feature">
                        <ul className="m-0 feature-conditiona">
                          <h6>{t("pages.vehicle_list.air_conditioner")}</h6>
                          <li><i className={`common_icon ${item?.vehicle_type_details?.air_conditioner}`}/></li>
                        </ul>
                        <ul className="m-0 feature-conditionb">
                          <h6>{t("pages.vehicle_list.no_smoking")}</h6>
                          <li>
                            <i className={`common_icon ${item?.vehicle_type_details?.smoking_allowed}`}/>
                          </li>
                        </ul>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              ))}
            </section>
            {
              props?.vehiclelist?.length === 0 ? (
                <NodatafoundPage
                  className={"col-xl-12 main-content offerlist-centent"}
                  image={no_orders}
                  button={""}
                  title={t("pages.No cabs found")}
                  description={""}
                />
              ) : (
                props?.vehiclelist?.data?.map((item, index) => (
                  <div className="list" key={index?.toString()}>
                    <Row>
                      <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 vehicle-image">
                        <img
                          alt="vehicle-img"
                          src={
                            item?.vehicle_image === null
                              ? default_car
                              : item?.vehicle_image[0]
                          }
                          className="vehicle-img"
                          onError={(e)=> {
                             e.target.src = default_car
                          }}
                        />
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2 vehicle">
                        <h5>
                          {item?.vehicle_type_details?.car_model
                            .charAt(0)
                            .toUpperCase() +
                            item?.vehicle_type_details?.car_model.slice(1)}
                        </h5>
                        {/* <h2>
                          {(
                            props.destination.kilometer *
                            item?.vehicle_type_details?.kilometer_wise_price
                          ).toFixed(2)}{" "}{process.env.REACT_APP_CURRENCY_SYMBOL}
                        </h2> */}
                        <h2>{(item?.price_to_display) }{" "}{process.env.REACT_APP_CURRENCY_SYMBOL}</h2>
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 kilometer">
                        <h5>{props.destination.kilometer} Kms</h5>
                        <div className="info">
                          <div>
                            {seatsDetail("seats", item)}
                          </div>
                          <div className="bags ms-2">
                            {seatsDetail("bags", item)}
                          </div>
                        </div>
                        {/* more info */}
                        {moreInfo(index)}
                      </div>
                      <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-center desktop-select">
                        <button
                          type="submit"
                          className="btn-submit hover-btn select-cab mt-4"
                          onClick={() => navigateTocabbook(item.id)}
                        >
                          {t("pages.vehicle_list.select_cab")}
                        </button>
                      </div>
                    </Row>
                    <Row>
                      {showinfo === index && (
                        <>
                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5"></div>
                          <div className="feature">
                            <ul className="m-0 ps-3">
                              <h6>{t("pages.vehicle_list.air_conditioner")}</h6>
                              <li><i className={`common_icon ${item?.vehicle_type_details?.air_conditioner}`}/></li>
                            </ul>
                            <ul className="m-0">
                              <h6>{t("pages.vehicle_list.no_smoking")}</h6>
                              <li>
                                <i className={`common_icon ${item?.vehicle_type_details?.smoking_allowed}`}/>
                              </li>
                            </ul>
                          </div>
                        </>
                      )}
                      <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 text-center mobile-select">
                        <button
                          type="submit"
                          className="btn-submit hover-btn select-cab mt-4"
                          onClick={() => navigateTocabbook(item.id)}
                        >
                          {t("pages.vehicle_list.select_cab")}
                        </button>
                      </div>
                    </Row>
                  </div>
                ))
              )
            }
            {props?.vehiclelist?.total > 10 && (
              <div className="text-end mt-2">
                <PaginationPage
                  changeCurrentpage={handlePageChange}
                  links={props?.vehiclelist?.links}
                />
              </div>
            )}
          </div>
        </Container>
        <Modifypopup callBackList={listVehiclerequest} />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  vehiclelist: state?.home?.vehiclelist,
  pickup: state?.home?.pickup,
  destination: state?.home?.destination,
  pickupdate_time: state?.home?.pickupdate_time,
  returndate_time: state?.home?.returndate_time,
  access_token: state?.login?.access_token,
  language: state?.languageState?.language,
  waytype: state?.home?.waytype,
});

export default connect(mapStateToProps, {
  maintainVehiclelist,
  maintainModify,
  fetchHeaderContent,
  maintainCabbook
})(VehiclelistPage);
